import * as tslib_1 from "tslib";
import { OnInit, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PromotionService } from '../services/promotion.service';
import { AlertController, LoadingController, ModalController, Platform } from '@ionic/angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SessionDisplayPipe } from '../pipes/session-display.pipe';
import { DiscountPricePipe } from '../pipes/discount-price.pipe';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Facebook } from '@ionic-native/facebook/ngx';
import { ShareService } from '../share.service';
import { Events } from '@ionic/angular';
import { TimezoneService } from '../services/timezone.service';
import { Meta } from '@angular/platform-browser';
import { GetImagePipe } from '../pipes/get-image.pipe';
import { PromotionDescriptionComponent } from '../modals/promotion-description/promotion-description.component';
import { EnvService } from '../env.service';
import { AlertService } from '../alert.service';
export class PromotionDetailsPage {
    constructor(route, router, ngZone, platform, alertCtrl, shareService, promotionService, sessiondisplaypipe, discountpricepipe, geolocation, loadingCtrl, fb, events, timezoneService, meta, getItem, modalCtrl, env, alertService) {
        this.route = route;
        this.router = router;
        this.ngZone = ngZone;
        this.platform = platform;
        this.alertCtrl = alertCtrl;
        this.shareService = shareService;
        this.promotionService = promotionService;
        this.sessiondisplaypipe = sessiondisplaypipe;
        this.discountpricepipe = discountpricepipe;
        this.geolocation = geolocation;
        this.loadingCtrl = loadingCtrl;
        this.fb = fb;
        this.events = events;
        this.timezoneService = timezoneService;
        this.meta = meta;
        this.getItem = getItem;
        this.modalCtrl = modalCtrl;
        this.env = env;
        this.alertService = alertService;
        this.directionsService = new google.maps.DirectionsService();
        this.directionsDisplay = new google.maps.DirectionsRenderer();
        this.currentLocation = {
            lat: 0,
            lng: 0
        };
        this.promotion = {};
        this.isMapInitiated = false;
        this.selectedActivityType = 'onsite';
        this.isActivityExpired = false;
        this.currentUser = null;
        this.markers = [];
        this.loaderShown = false;
        this.currentUser = JSON.parse(localStorage.getItem('pToken'));
        events.subscribe('user:reload', (userData) => {
            this.currentUser = JSON.parse(localStorage.getItem('pToken'));
        });
        this.route.params.subscribe(params => {
            if (params.id) {
                this.loaderShown = true;
                this.showLoader();
                this.getSinglePromotionData(params.id, { scope: ['categories', 'class', 'terms', 'promoter', 'session_type', 'sessions'] });
                amplitude.logEvent("mobile::visited_promotion_detail_view_page", { 'promotionId': params.id });
            }
        });
        this.userTimezone = timezoneService.getUserTimezone();
    }
    showLoader() {
        let component = this;
        this.loadingCtrl.create({
            message: 'Loading...'
        }).then((res) => {
            if (component.loaderShown) {
                res.present();
                res.onDidDismiss().then((dis) => {
                    this.hideLoader();
                });
            }
        });
    }
    hideLoader() {
        setTimeout(() => {
            this.loadingCtrl.dismiss();
        }, 1000);
    }
    calculateAndDisplayRoute(myPos) {
        const that = this;
        this.directionsService.route({
            origin: new google.maps.LatLng(myPos.latitude, myPos.longitude),
            destination: new google.maps.LatLng(this.promotion.class.venue.lat, this.promotion.class.venue.lng),
            travelMode: 'DRIVING'
        }, (response, status) => {
            if (status === 'OK') {
                that.directionsDisplay.setDirections(response);
            }
            else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    }
    showStudio(promo) {
        console.log(promo);
        this.router.navigate(['/venue', promo.class.venue.username], { queryParams: { classId: promo.class.id } });
    }
    copyUrlToClipboard() {
        const tempElement = document.createElement('textarea');
        tempElement.value = this.env.BASE_URL + 'promotion/' + this.promotion.id;
        tempElement.setAttribute('readonly', '');
        tempElement.style.position = 'absolute';
        tempElement.style.left = '-9999px';
        document.body.appendChild(tempElement);
        tempElement.select();
        document.execCommand('copy');
        document.body.removeChild(tempElement);
        this.alertService.presentToast('Link Copied!');
        amplitude.logEvent("mobile::copied_promotion_share_url", { 'promotionId': this.promotion.id });
    }
    loadMap(lat = 49.2569777, lng = -123.123904) {
        const mapOptions = {
            center: { lat, lng },
            minZoom: 10,
            zoom: 13,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: google.maps.ControlPosition.LEFT_TOP
            },
        };
        this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
        this.directionsDisplay.setMap(this.map);
        // Add location marker after load the map
        this.addMarkerToMap();
    }
    addMarkerToMap() {
        // Create a marker with selected promotion
        const marker = {
            position: {
                lat: parseFloat(this.promotion.class.venue.lat),
                lng: parseFloat(this.promotion.class.venue.lng),
            },
            title: this.promotion.classes.title,
            icon: 'assets/images/map-icon-light.png',
            url: `${window.location.origin}#/promotion/${this.promotion.id}`
        };
        const promoMarker = new google.maps.Marker({
            position: marker.position,
            map: this.map,
            title: marker.title,
            icon: marker.icon,
            url: marker.url,
        });
        // Add location info window
        const infoWindow = new google.maps.InfoWindow({
            content: marker.title
        });
        infoWindow.open(this.map, promoMarker);
        google.maps.event.addListener(promoMarker, 'click', function () {
            infoWindow.open(this.map, promoMarker);
        });
    }
    getDirections() {
        // this.platform.ready().then(() => {
        //   console.log('get direction clicked');
        //   this.geolocation.getCurrentPosition({maximumAge: 1000, timeout: 5000,
        //     enableHighAccuracy: true }).then((resp) => {
        //     console.log('get current position');
        //     console.log('latitude', resp.coords.latitude);
        //     console.log('longitude', resp.coords.longitude);
        //    }).catch((error) => {
        //      console.log('Error getting location', error);
        //    });
        // });
        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        function success(pos) {
            const crd = pos.coords;
            console.log('Your current position is:');
            console.log(`Latitude : ${crd.latitude}`);
            console.log(`Longitude: ${crd.longitude}`);
            console.log(`More or less ${crd.accuracy} meters.`);
        }
        function error(err) {
            console.warn(`ERROR(${err.code}): ${err.message}`);
        }
        navigator.geolocation.getCurrentPosition(success, error, options);
    }
    getNextSessionTimestamp() {
        return _(this.promotion.next_sessions)
            .map('startdate_timestamp')
            .sortBy()
            .first();
    }
    getLastClassDate() {
        return _(this.promotion.next_sessions)
            .map('startdate_timestamp')
            .sortBy()
            .last();
    }
    presentAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'This activity holds an optional AfterSocial. Please go to the activity to find out more.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    getSinglePromotionData(id, options) {
        this.promotionService.getPromotion(id, options).subscribe((data) => {
            if (data) {
                this.promotion = this.convertPromotionTimezone(data.result);
                if (this.promotion.class.instructor) {
                    if ((this.promotion.class.instructor.is_invited == 1 && this.promotion.class.instructor.invitation_status !== 'ACCEPTED') ||
                        (this.promotion.class.instructor.is_invited == 1 && this.promotion.class.instructor.invitation_status == 'ACCEPTED' && !this.promotion.class.instructor.is_profile_completed)) {
                        this.promotion.class.instructor = this.promotion.promoter;
                    }
                }
                this.selectedActivityType = this.promotion.is_onsite_full ? this.promotion.is_online_full ? '' : 'online' : 'onsite';
                this.isActivityExpired = moment().isAfter(moment(this.promotion.classes.last_session));
                // Add dynamci image in to og meta tags
                this.meta.updateTag({ property: 'og:image', content: this.getItem.transform(this.promotion, 'cover') });
                this.ngZone.run(() => {
                    this.loadMap(parseFloat(this.promotion.class.venue.lat), parseFloat(this.promotion.class.venue.lng));
                });
                this.createShareMessage();
                this.categories = _(this.promotion.categories)
                    .reject({ cat_parent: 0 })
                    .map('cat_name')
                    .value()
                    .join(', ');
                this.promotionSchedule = _(this.promotion.class.schedule)
                    .groupBy('day')
                    .value();
                this.promotionSchedule = this.sortScheduleByDay(this.promotionSchedule);
                this.loaderShown = false;
                this.hideLoader();
            }
        });
    }
    convertPromotionTimezone(promotion) {
        let timezoneService = this.timezoneService;
        let timezone = promotion.class.venue.time_zone;
        let isOnlineClass = promotion.class.online_locations && promotion.class.online_locations.length > 0;
        let convertedTime = timezoneService.convertScheduleToUserTimezone(promotion.sessions, promotion.class.schedule, isOnlineClass, timezone);
        promotion.sessions = convertedTime['sessions'];
        promotion.class.schedule = convertedTime['schedule'];
        promotion.next_sessions.map(session => {
            session.startdate_timestamp = timezoneService.convertUtcToUserTimezone(session.startdate_timestamp, isOnlineClass, timezone);
        });
        promotion.classes.first_session = timezoneService.convertUtcToUserTimezone(promotion.classes.first_session, isOnlineClass, timezone);
        return promotion;
    }
    ngOnInit() {
    }
    shareFacebook() {
        this.shareService.shareToFacebook(this.env.BASE_URL + 'promotion/' + this.promotion.id);
        amplitude.logEvent("mobile::clicked_promotion_fb_share", { 'promotionId': this.promotion.id });
    }
    shareTwitter() {
        amplitude.logEvent("mobile::clicked_promotion_twitter_share", { 'promotionId': this.promotion.id });
    }
    shareEmail() {
        amplitude.logEvent("mobile::clicked_promotion_email_share", { 'promotionId': this.promotion.id });
    }
    createShareMessage() {
        if (this.promotion) {
            const nl = encodeURI('\n\r');
            const emailMessageBody = 'Hi' +
                nl + nl + 'Check out this cool activity on Promoga!' +
                nl + nl + this.sessiondisplaypipe.transform(this.promotion.session_value) +
                ' of ' + this.promotion.class.title + ' ' + this.discountpricepipe.transform(this.promotion) +
                nl + nl + this.shareService.shareToEmail(this.env.BASE_URL + 'promotion/' + this.promotion.id) +
                nl + nl + 'Cheers,';
            this.emailBody = emailMessageBody;
            this.twitterShareUrl = this.shareService.shareToTwitter(this.env.BASE_URL + 'promotion/' + this.promotion.id);
        }
    }
    purchasePromotion(promotion) {
        if (this.promotion.user_id == 165 || this.promotion.user_id == 166 || this.promotion.user_id == 175
            || this.promotion.user_id == 176 || this.promotion.user_id == 177) {
            this.showProxyClassFullAlert();
            return;
        }
        if (this.currentUser && this.currentUser.user && this.currentUser.user.source == 'promoga' &&
            this.currentUser.user.email_verified == 0) {
            this.showEmailVerifyAlert();
            return;
        }
        if (promotion.class.medium && promotion.class.medium.length == 2) {
            if (this.promotion.is_onsite_full && this.promotion.is_online_full) {
                this.showClassFullAlert();
                return;
            }
            return this.presentAlertConfirm(promotion);
        }
        var classType = (promotion.class.online_locations && promotion.class.online_locations.length > 0) ? 'online' : 'onsite';
        //For triggering Mixpanel event for Join now click
        this.promotionService.joinPromotion(promotion.id).subscribe((data) => { });
        amplitude.logEvent("mobile::clicked_promotion_join_now_button", { 'promotionId': this.promotion.id, 'classType': classType, 'instructionMode': classType });
        const navigationExtras = { state: { promo: promotion, redirect: '/purchase-promotion' } };
        this.router.navigate(['/purchase-promotion'], navigationExtras);
    }
    presentAlertConfirm(promotion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: this.selectedActivityType == 'onsite' ? 'Are you sure you want to take an onsite class?' : 'Are you sure you want to take an online class?',
                buttons: [
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'popup-cancel-button',
                        handler: () => {
                            // console.log('Confirm Cancel');
                        }
                    }, {
                        text: 'Ok',
                        cssClass: 'button-positive',
                        handler: () => {
                            promotion['selectedActivityType'] = this.selectedActivityType;
                            amplitude.logEvent("mobile::clicked_promotion_join_now_button", { 'promotionId': this.promotion.id, 'classType': 'hybrid', 'instructionMode': this.selectedActivityType });
                            const navigationExtras = { state: { promo: promotion, redirect: '/purchase-promotion' } };
                            this.router.navigate(['/purchase-promotion'], navigationExtras);
                        }
                    }
                ]
            });
            yield alert.present();
        });
    }
    showEmailVerifyAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'Please verify your email address.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    showClassFullAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'Sorry, this activity is full.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    showProxyClassFullAlert() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                message: 'This activity is currently full. Check back to see new spots open up',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    showInstructor(usr) {
        this.router.navigate(['/' + usr.username]);
    }
    openTooltip(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            event.stopPropagation();
            const alert = yield this.alertCtrl.create({
                message: 'Online events are displayed in your local timezone.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    sortScheduleByDay(schedule) {
        if (!schedule) {
            return [];
        }
        let days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        let sortedSchedule = [];
        days.map(day => {
            if (schedule[day]) {
                let session = {};
                session['day'] = day;
                session['times'] = schedule[day];
                sortedSchedule.push(session);
            }
        });
        return sortedSchedule;
    }
    showDescription(description) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.modalCtrl.create({
                component: PromotionDescriptionComponent,
                cssClass: 'description-modal-css',
                componentProps: {
                    description: description
                }
            });
            yield alert.present();
        });
    }
    ngOnDestroy() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalCtrl.getTop();
            if (modal) {
                modal.dismiss();
            }
        });
    }
}
